/**
 * 参数组key映射表
 * specs & 对比页 会按照该顺序排序
 */
export const specGroupGeneralKeyMap: any = {
    spec_group_quick_look: 'specs_quick_look',
    spec_group_capacity: 'specs_capacity',
    spec_group_extra_battery: 'specs_extra_battery',
    spec_group_output: 'specs_output',
    spec_group_input: 'specs_input',
    spec_group_battery: 'specs_battery',
    spec_group_general: 'specs_general',
    spec_group_supported_battery: 'specs_supported_battery',
    spec_group_environmental_operating_temperature: 'specs_operating_temp',
    spec_group_what_in_the_box: 'specs_whats_in_the_box',
};

/** 参数名key映射表 */
export const specGeneralKeyMap = {
    specs_what_in_the_box: 'specs_whats_in_the_box',
    specs_mobile_app: 'specs_mobile_app',
    specs_ac_charging: 'specs_input_ac_charging',
    specs_solar_charging: 'specs_input_solar_charging',
    specs_car_charging: 'specs_input_car_charging',
};
